import type { FC } from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { CabinetTitlePage } from 'components/layout';
import { Guard, usePermissionGuard } from 'features/login';

const TABS = [
  { label: 'By ads', path: 'by-ads' },
  { label: 'By hypothesis', path: 'by-hypothesis' },
];

const TestingHistoryPage: FC = () => {
  const { accessToViewAdlog } = usePermissionGuard();
  const navigate = useNavigate();
  const location = useLocation();

  const activeTab = TABS.findIndex((t) =>
    location.pathname.endsWith(t.path),
  );
  const currentTab = activeTab === -1 ? 0 : activeTab;

  const handleTabChange = (_: React.SyntheticEvent, index: number) => {
    navigate(TABS[index].path, { replace: true });
  };

  return (
    <Guard hasAccess={accessToViewAdlog} fallback>
      <CabinetTitlePage title="Testing History" />
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs value={currentTab} onChange={handleTabChange}>
          {TABS.map((tab) => (
            <Tab key={tab.path} label={tab.label} />
          ))}
        </Tabs>
      </Box>
      <Outlet />
    </Guard>
  );
};

export default TestingHistoryPage;
